<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0049 1.66992C14.6082 1.66992 18.3399 5.40163 18.3399 10.0049C18.3399 14.6082 14.6082 18.3399 10.0049 18.3399C5.40163 18.3399 1.66992 14.6082 1.66992 10.0049C1.66992 5.40163 5.40163 1.66992 10.0049 1.66992ZM10.0215 14.7342C10.483 14.7342 10.8571 14.3601 10.8571 13.8986V8.88505C10.8571 8.42357 10.483 8.04946 10.0215 8.04946C9.56003 8.04946 9.18592 8.42357 9.18592 8.88505V13.8986C9.18592 14.3601 9.56003 14.7342 10.0215 14.7342ZM9.01885 6.21123C9.01885 5.65745 9.46778 5.20852 10.0216 5.20852C10.5753 5.20852 11.0243 5.65745 11.0243 6.21123C11.0243 6.76501 10.5753 7.21394 10.0216 7.21394C9.46778 7.21394 9.01885 6.76501 9.01885 6.21123Z"
      fill="currentColor"
    />
  </svg>
</template>
